import axios from 'axios';
import { Component } from 'react';
import { Button } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import { Field, reduxForm } from 'redux-form';
import swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import {
  AGREEMENT_URL,
  default as config,
  PRIVACY_URL
} from '../constants/constants';
import logoInflo from '../images/inflo_logo.png';
require('../features/login/styles/login-inflo.css');

const logo = require('../images/logo_new.png');

const validate = (values) => {
  const errors = {};
  if (!values.password) {
    errors.password = 'Required';
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = 'Required';
  }
  return errors;
};

const renderField = ({
  input,
  label,
  type,
  meta: { asyncValidating, touched, error }
}) => (
  <div>
    {/*<label>{label}</label>*/}
    <div
      className={asyncValidating ? 'async-validating' : ''}
      style={{ marginBottom: '15px' }}
    >
      <input
        {...input}
        type={type}
        placeholder={label}
        className="styleFieldLogin"
      />
      {touched && error && (
        <span className="error" style={{ marginLeft: '-210px' }}>
          {error}
        </span>
      )}
    </div>
  </div>
);

let ResetPasswordForm = (props) => {
  const { handleSubmit, submitting } = props;
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <Field
          name="password"
          component={renderField}
          type="password"
          label="Password"
        />
        <Field
          name="confirmPassword"
          component={renderField}
          type="password"
          label="Password confirmation"
        />
      </div>
      {/*<div style={{marginTop:'50px'}}>
                <button className='btn login-button' type="submit" disabled={submitting}>Submit</button>
            </div>*/}
      <div style={{ textAlign: 'center' }}>
        <button
          className="btn login-button"
          type="submit"
          disabled={submitting}
        >
          Submit
        </button>
      </div>
    </form>
  );
};

class ResetPasswordPage extends Component {
  handleSubmit = (values) => {
    if (values.password !== values.confirmPassword) {
      swal({
        imageUrl: logoInflo,
        title: '<div class="titleModal">Notice</div>',
        html:
          '<p class="contentModal">Password confirmation and Password must match.</p>',
        showConfirmButton: false,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false
      });
    } else {
      var password = values.password;
      var code = this.props.match.params.code;

      const redirectToLogin = () => {
        this.props.history.push('/');
      };

      var request = axios.put(
        `${config.serverURL}/users/resetPassword?password=${password}&code=${code}`
      );
      request
        .then(() => {
          swal({
            imageUrl: logoInflo,
            title: '<div class="titleModal">Notice</div>',
            html:
              '<p class="contentModal">The password has successfully changed.</p><p class="contentModal">Please login.</p>',
            showConfirmButton: false,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false
          }).then(function() {
            redirectToLogin();
          });
        })
        .catch(function(error) {
          if (error.response) {
            if (error.response.status === 423) {
              swal({
                imageUrl: logoInflo,
                title: '<div class="titleModal">Notice</div>',
                html:
                  '<p class="contentModal">The link to reset your password has expired!</p><p class="contentModal">Please repeat the process.</p>',
                showConfirmButton: false,
                showCloseButton: true,
                background: '#121C24',
                allowOutsideClick: false
              }).then(function() {
                redirectToLogin();
                document.getElementById('forgotPassword').style.display =
                  'block';
              });
            }
            if (error.response.status === 403) {
              swal({
                imageUrl: logoInflo,
                title: '<div class="titleModal">Notice</div>',
                html:
                  '<p class="contentModal">This link is not valid any more!</p>',
                showConfirmButton: false,
                showCloseButton: true,
                background: '#121C24',
                allowOutsideClick: false
              }).then(function() {
                redirectToLogin();
              });
            }
          }
        });
    }
  };

  render() {
    return (
      <div className="paddingBlock login-page">
        <Dialog
          ref={(el) => {
            this.dialog = el;
          }}
        />
        <div className="row" style={{ marginRight: '0px', height: '87%' }}>
          <div className="col-md-4 loginForm">
            <div
              style={{
                textAlign: 'center',
                marginBottom: '-25px',
                marginTop: '-15px'
              }}
            >
              <img style={{ width: '90%' }} src={logo} alt="logo" />
            </div>
            <div className="textLogo">Sign in to Inflo Portal</div>
            <ResetPasswordForm onSubmit={this.handleSubmit} />
            <div className="row">
              <div id="links">
                © Copyright {new Date().getFullYear()} Inflo, Inc. |
                <Button className="linkpa" bsStyle="link" href={PRIVACY_URL}>
                  Privacy Policy
                </Button>
                |
                <Button className="linkpa" bsStyle="link" href={AGREEMENT_URL}>
                  License Agreement
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ResetPasswordForm = reduxForm({
  form: 'resetPasswordForm',
  validate
})(ResetPasswordForm);

// const mapStateToProps = store => {
//     return {

//     };
// };

// export default (connect(mapStateToProps)(ResetPasswordPage));

export default ResetPasswordPage;
